import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';

export default function Home() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [visibleProducts, setVisibleProducts] = useState(9);
  const [currentSlide, setCurrentSlide] = useState(0);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  const brands = [
    { 
      id: 'newlong', 
      name: 'Newlong', 
      logo: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/f2b617eed5e7647395dce8fe58c3890f.jpeg', 
      country: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/537ff34f85eba9c005ffa7910a85dd0b.png' 
    },
    { 
      id: 'union', 
      name: 'Union Special', 
      logo: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/9187b83bebeb3c1f0d4fa5803f85d02c.jpeg', 
      country: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/537ff34f85eba9c005ffa7910a85dd0b.png' 
    },
    { 
      id: 'brasil', 
      name: 'Brasil', 
      logo: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/672afb5cf59e013fdde9185f3818d110.jpeg', 
      country: 'https://public.readdy.ai/ai/img_res/4dc2233cba9a02baf02b71dd63e58521.jpg' 
    },
    { 
      id: 'china', 
      name: 'China', 
      logo: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/32693be9c339552c7743abb396f02e2e.jpeg', 
      country: 'https://readdy.ai/api/search-image?query=China%20national%20flag%20rectangular%20shape%20official%20colors%20red%20yellow%20stars%20clean%20design&width=120&height=80&seq=china-flag-v1&orientation=landscape' 
    }
  ];

  const categories = [
    { id: 'all', name: 'Todos los Productos' },
    { id: 'bag-closing', name: 'Newlong Cerradora Industriales' },
    { id: 'bag-making', name: 'Newlong Fabricación Sacos' },
    { id: 'spare-parts', name: 'Newlong Partes' },
    { id: 'waig', name: 'Waig Maquinas Industriales' },
    { id: 'thread', name: 'Hilo Polyester' },
    { id: 'union-special', name: 'Union Special' },
    { id: 'organ-needles', name: 'Agujas Organ' },
    { id: 'motors-tables', name: 'Motores y Mesas' }
  ];

  const products = [
    // Primeros 9 productos destacados
    {
      id: 6,
      name: 'Newlong NP-7A',
      category: 'bag-closing',
      image: 'https://public.readdy.ai/ai/img_res/55ca21cd-e46b-4442-b0b6-77937e50beaf.png',
      features: ['Sistema automático', 'Producción continua', 'Alta eficiencia', 'Fácil ajuste', 'Fabricado en Japón']
    },
    {
      id: 37,
      name: 'Waig WB-DAP',
      category: 'waig',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/7ac301b71aeae70892f8364b28e96036.jpeg',
      features: ['Versión profesional', 'Control digital', 'Alto rendimiento', 'Versatilidad de aplicaciones', 'Soporte técnico']
    },
    {
      id: 5,
      name: 'Newlong NP-3',
      category: 'bag-closing',
      image: 'https://public.readdy.ai/ai/img_res/1831b693-a6bc-4c57-9be6-6410326a14b9.png',
      features: ['Diseño compacto', 'Fácil operación', 'Bajo mantenimiento', 'Alta precisión', 'Calidad japonesa']
    },
    {
      id: 39,
      name: 'Hilo Poliéster Industrial 5000m',
      category: 'thread',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/96469ec8f6ea75382cc26b30be2bc810.jpeg',
      features: ['Bobinas de 5000m', 'Alta resistencia', 'Múltiples colores disponibles', 'Para uso industrial', 'Poliéster reforzado']
    },
    {
      id: 36,
      name: 'Waig WS-AR',
      category: 'waig',
      image: 'https://public.readdy.ai/ai/img_res/2e9d5e12-259f-4984-b27a-5f17448bed53.png',
      features: ['Construcción robusta', 'Alta capacidad', 'Tecnología avanzada', 'Bajo mantenimiento', 'Garantía extendida']
    },
    {
      id: 11,
      name: 'Looper',
      category: 'spare-parts',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/9dfe680d3624ad2bccb06f5c7d602b84.jpeg',
      features: ['Repuesto original Newlong', 'Alta calidad', 'Acero japonés', 'Fácil instalación', 'Compatible múltiples modelos']
    },
    {
      id: 12,
      name: 'Knife Newlong',
      category: 'spare-parts',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/1b90998b2cb70d219691144ef82de858.jpeg',
      features: ['Rodamiento original', 'Precisión japonesa', 'Alta durabilidad', 'Bajo mantenimiento', 'Calidad garantizada']
    },
    {
      id: 38,
      name: 'Waig CW980',
      category: 'waig',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/a47628fdd495228c36f57e8bbb9e7c4c.png',
      features: ['Servicio pesado', 'Máxima durabilidad', 'Para condiciones extremas', 'Motor potente', 'Construcción reforzada']
    },
    {
      id: 40,
      name: 'Hilo Poliéster Heavy Duty',
      category: 'thread',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/3814b43b348773eef9803221c270a836.jpeg',
      features: ['Grado industrial', 'Extra resistente', 'Para sacos pesados', 'Durabilidad superior', 'Resistente a UV']
    },

    // Resto del catálogo
    {
      id: 1,
      name: 'Newlong DS-2',
      category: 'bag-closing',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d24718cf39c4e65225bf8ddfdc88b492.png',
      features: ['Portátil y liviana', 'Costura de alta calidad', 'Fácil operación', 'Ideal para sacos', 'Fabricado en Japón']
    },
    {
      id: 2,
      name: 'Newlong DS-2II',
      category: 'bag-closing',
      image: 'https://public.readdy.ai/ai/img_res/b83c8a1f-a62a-47a8-92ad-02552e4c3258.png',
      features: ['Versión mejorada DS-2', 'Mayor durabilidad', 'Control avanzado', 'Alta velocidad', 'Tecnología japonesa']
    },
    {
      id: 3,
      name: 'Newlong DS-2W',
      category: 'bag-closing',
      image: 'https://public.readdy.ai/ai/img_res/dad99827-5469-4e52-a7b6-6ba2f8d1ce8b.png',
      features: ['Formato ancho', 'Construcción robusta', 'Alta durabilidad', 'Costura reforzada', 'Fabricado en Japón']
    },
    {
      id: 4,
      name: 'Newlong Parts',
      category: 'bag-closing',
      image: 'https://public.readdy.ai/ai/img_res/68dedc5c-61b6-48cd-9162-84533ab56673.png',
      features: ['Alta velocidad', 'Mecanismo avanzado', 'Costura rápida', 'Eficiencia superior', 'Tecnología japonesa']
    },
    {
      id: 7,
      name: 'Newlong DN-2',
      category: 'bag-making',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/9bc4b55f33b55755441aa16b975fe11d.jpeg',
      features: ['Versátil y robusta', 'Alta capacidad', 'Tecnología avanzada', 'Fácil operación', 'Fabricado en Japón']
    },
    {
      id: 8,
      name: 'Newlong DKN-3',
      category: 'bag-making',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/acd47e2b28fa7c228a54439096161ff6.jpeg',
      features: ['Producción eficiente', 'Control preciso', 'Bajo consumo', 'Alta durabilidad', 'Tecnología japonesa']
    },
    {
      id: 13,
      name: '3-16S28029 Screw',
      category: 'spare-parts',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/9a73d8eee51f2eeac53097095931920e.jpeg',
      features: ['Tornillo original Newlong', 'Acero de alta resistencia', 'Precisión perfecta', 'Fácil instalación', 'Fabricado en Japón']
    },
    {
      id: 14,
      name: '5-16N24201 Nut',
      category: 'spare-parts',
      image: 'https://public.readdy.ai/ai/img_res/e20fcb1c-9bc9-4dd4-bd31-347a3206555e.png',
      features: ['Tuerca original', 'Alta resistencia', 'Ajuste perfecto', 'Durabilidad extrema', 'Fabricado en Japón']
    },
    {
      id: 15,
      name: '6A04001 RodEnd',
      category: 'spare-parts',
      image: 'https://public.readdy.ai/ai/img_res/2a95d043-a578-4b5c-bccd-b09e0b1d7155.png',
      features: ['Extremo de varilla original', 'Precisión mecánica', 'Alta durabilidad', 'Fácil reemplazo', 'Fabricado en Japón']
    },
    {
      id: 41,
      name: 'Set Hilos Poliéster Multicolor',
      category: 'thread',
      image: 'https://public.readdy.ai/ai/img_res/d0e25dec-f905-4971-8e50-ae398cd8918e.png',
      features: ['Set de 12 colores', 'Bobinas de 3000m', 'Alta calidad', 'Colores vibrantes', 'Para diferentes aplicaciones']
    },
    {
      id: 42,
      name: 'Union Special 80800',
      category: 'union-special',
      image: 'https://image2url.com/r2/default/images/1771520997713-59adae45-96a8-448d-b369-ed42131cc00f.png',
      features: ['Ingeniería alemana', 'Precisión superior', 'Alta velocidad', 'Construcción robusta', 'Garantía de fábrica']
    },
    {
      id: 43,
      name: 'Union Special 63900',
      category: 'union-special',
      image: 'https://image2url.com/r2/default/images/1771521259906-37adab20-abae-4085-adf9-b4739d6c72c2.png',
      features: ['Tecnología avanzada', 'Versatilidad de uso', 'Fácil operación', 'Mantenimiento reducido', 'Fabricado en Alemania']
    },
    {
      id: 44,
      name: 'Union Special 39500',
      category: 'union-special',
      image: 'https://image2url.com/r2/default/images/1771521335489-f79b7f25-5e08-4fdd-8015-8e5b250035ac.jpg',
      features: ['Costura especializada', 'Control preciso', 'Alta eficiencia', 'Durabilidad alemana', 'Repuestos disponibles']
    },
    {
      id: 45,
      name: 'Repuestos Union Special',
      category: 'union-special',
      image: 'https://image2url.com/r2/default/images/1771521464153-59c4df7a-d6ec-46dd-9998-f89cb903542c.png',
      features: ['Repuestos originales', 'Serie 80000', 'Ingeniería alemana', 'Alta precisión', 'Certificación de calidad']
    },
    {
      id: 46,
      name: 'Agujas Organ para Cerradoras',
      category: 'organ-needles',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/4398eeed7803feff83274692d1ad0c9c.webp',
      features: ['Agujas originales Organ', 'Todo tipo de cerradoras', 'Acero japonés de alta calidad', 'Compatible con Newlong DS-2/DS-9', 'Paquete de 10 unidades']
    },
    {
      id: 47,
      name: 'Agujas Organ para Sacos',
      category: 'organ-needles',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/fccc5aad199758c4e299ce94287efa2f.webp',
      features: ['Agujas industriales Organ', 'Acero Reforzado', 'Para sacos de alta resistencia', 'Cromadas anti-corrosión', 'Durabilidad superior']
    },
    {
      id: 48,
      name: 'Mesa Industrial Completa 302-K',
      category: 'motors-tables',
      image: 'https://public.readdy.ai/ai/img_res/2d12fbd8-4321-4ca7-b863-afc7fdf5a188.png',
      features: ['Mesa de acero reforzado', 'Altura ajustable ergonómica', 'Compatible con cerradoras Newlong', 'Superficie antivibración', 'Incluye soporte para motor']
    },
    {
      id: 49,
      name: 'Motor Clutch Industrial 1/2 HP',
      category: 'motors-tables',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/4a1220897f06acadd21cac5bb7e9ded6.png',
      features: ['Motor embrague 1/2 HP', 'Alta potencia industrial', 'Arranque suave progresivo', 'Para trabajo pesado continuo', 'Durabilidad garantizada']
    },
    {
      id: 50,
      name: 'Mesa de Trabajo Industrial Reforzada',
      category: 'motors-tables',
      image: 'https://public.readdy.ai/ai/img_res/adc96047-53b8-4f63-bff5-4861b4ad01eb.png',
      features: ['Estructura de acero reforzado', 'Altura ajustable 75-95cm', 'Compatible Newlong/Union Special', 'Superficie antivibración', 'Fácil ensamblaje sin soldadura']
    },
    {
      id: 51,
      name: 'Motor Servo Digital 550W',
      category: 'motors-tables',
      image: 'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/34cc7265847e3e7439933df46f7aa45f.png',
      features: ['Motor servo 550W eficiente', 'Bajo consumo energético 70%', 'Control digital de velocidad', 'Operación silenciosa', 'Pedal de control incluido']
    }
  ];

  const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);

  // Carrusel de imágenes
  const carouselImages = [
    'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/97916f539fdbf7a81d0e5b97d2881251.jpeg',
    'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/5bde57057f1e371f946a89692acbf5e1.jpeg',
    'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/fc68332ae9f55c91e94c38c69e6540d1.jpeg',
    'https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/96469ec8f6ea75382cc26b30be2bc810.jpeg'
  ];

  // Auto-play del carrusel
  useEffect(() => {
    if (carouselImages.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
      }, 4000);
      return () => clearInterval(interval);
    }
  }, [carouselImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d03d7dd558dd59549242c09cb047b58f.png" 
                alt="IKIGAI Global Group Inc." 
                className="h-14 w-auto"
              />
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-10 items-center">
              <a href="#inicio" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.home', 'Inicio')}</a>
              <a href="#productos" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.products', 'Productos')}</a>
              <a href="#marcas" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.brands', 'Marcas')}</a>
              <a href="#contacto" className="text-gray-700 hover:text-blue-600 cursor-pointer whitespace-nowrap font-medium text-sm uppercase tracking-wide transition-colors">{t('nav.contact', 'Contacto')}</a>
              
              {/* Language Toggle */}
              <button 
                onClick={toggleLanguage}
                className="flex items-center space-x-2 px-4 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors"
              >
                <i className="ri-global-line text-gray-600"></i>
                <span className="text-sm font-medium text-gray-700">
                  {i18n.language === 'es' ? 'EN' : 'ES'}
                </span>
              </button>

              <Link to="/solicitar-cotizacion" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap text-sm">
                Cotización Gratuita
              </Link>
            </nav>

            {/* Mobile menu button */}
            <button 
              className="lg:hidden p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="ri-menu-line text-xl text-gray-700"></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden py-4 border-t border-gray-200">
              <nav className="flex flex-col space-y-2">
                <a href="#inicio" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.home', 'Inicio')}</a>
                <a href="#productos" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.products', 'Productos')}</a>
                <a href="#marcas" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.brands', 'Marcas')}</a>
                <a href="#contacto" className="text-gray-700 hover:text-blue-600 cursor-pointer py-2 font-medium">{t('nav.contact', 'Contacto')}</a>
                <button 
                  onClick={toggleLanguage}
                  className="flex items-center space-x-2 px-3 py-2 text-left"
                >
                  <i className="ri-global-line text-gray-600"></i>
                  <span className="text-sm font-medium text-gray-700">
                    {i18n.language === 'es' ? 'English' : 'Español'}
                  </span>
                </button>
                <Link to="/solicitar-cotizacion" className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors whitespace-nowrap text-sm mt-4 text-center block">
                  Cotización Gratuita
                </Link>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Hero Section */}
      <section id="inicio" className="relative bg-gradient-to-br from-gray-900 via-blue-900 to-gray-800 text-white py-32"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=large%20industrial%20textile%20factory%20with%20massive%20industrial%20sewing%20machines%20bag%20closing%20equipment%20production%20lines%20workers%20in%20safety%20gear%20modern%20manufacturing%20facility%20high%20ceilings%20professional%20lighting%20industrial%20atmosphere%20Latin%20America&width=1400&height=700&seq=hero-industrial-factory&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 via-gray-900/80 to-blue-900/90"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="w-full text-center">
            <div className="mb-6">
              <span className="inline-block px-4 py-2 bg-blue-600/20 border border-blue-400/30 rounded-full text-blue-200 text-sm font-medium uppercase tracking-wide">
                Distribución Directa de Fábrica
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-8 text-white leading-tight">
              Maquinaria Industrial
              <span className="block text-blue-300">de Clase Mundial</span>
            </h1>
            <p className="text-xl md:text-2xl mb-12 max-w-4xl mx-auto text-gray-200 leading-relaxed">
              Especialistas en equipos Newlong (Japón) y Union Special (Alemania) para el sector industrial. 
              Distribución directa desde Miami hacia toda Latinoamérica.
            </p>
            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <button 
                onClick={() => {
                  const element = document.getElementById('productos');
                  element?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-lg font-semibold transition-all whitespace-nowrap shadow-xl text-lg hover:shadow-2xl transform hover:-translate-y-1 cursor-pointer"
              >
                Explorar Catálogo
              </button>
              <Link to="/solicitar-cotizacion" className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-10 py-4 rounded-lg font-semibold transition-all whitespace-nowrap text-lg hover:shadow-xl transform hover:-translate-y-1 text-center">
                Solicitar Cotización
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">25+</div>
              <div className="text-gray-600 font-medium">Años de Experiencia</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">3</div>
              <div className="text-gray-600 font-medium">Centros de Distribución</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
              <div className="text-gray-600 font-medium">Clientes Satisfechos</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">15</div>
              <div className="text-gray-600 font-medium">Países Atendidos</div>
            </div>
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <section id="marcas" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Marcas Líderes Mundiales</h2>
            <p className="text-xl text-gray-600">Distribuidores de las marcas más prestigiosas en maquinaria industrial</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="p-10 text-center">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <img 
                    src={brands[0].logo} 
                    alt="Newlong Japan"
                    className="h-20 object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Newlong - Japón</h3>
                <p className="text-gray-600 text-base leading-relaxed mb-5">Líder mundial en tecnología de cerrado de sacos con más de 70 años de experiencia. Reconocida por su precisión, durabilidad e innovación constante.</p>
                <div className="flex justify-center space-x-3">
                  <span className="px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-xs font-medium">Precisión Japonesa</span>
                  <span className="px-3 py-1.5 bg-green-100 text-green-800 rounded-full text-xs font-medium">70+ Años</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="p-10 text-center">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <img 
                    src={brands[1].logo} 
                    alt="Union Special Germany"
                    className="h-20 object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Union Special - Alemania</h3>
                <p className="text-gray-600 text-base leading-relaxed mb-5">Ingeniería alemana de precisión en maquinaria de costura industrial. Especialistas en soluciones robustas para los sectores más exigentes.</p>
                <div className="flex justify-center space-x-3">
                  <span className="px-3 py-1.5 bg-red-100 text-red-800 rounded-full text-xs font-medium">Ingeniería Alemana</span>
                  <span className="px-3 py-1.5 bg-purple-100 text-purple-800 rounded-full text-xs font-medium">Alta Robustez</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="p-10 text-center">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <img 
                    src={brands[2].logo} 
                    alt="Waig Brasil"
                    className="h-20 object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Waig - Brasil</h3>
                <p className="text-gray-600 text-base leading-relaxed mb-5">Fabricante brasileño de maquinaria industrial de alta calidad. Soluciones robustas y económicas adaptadas al mercado latinoamericano.</p>
                <div className="flex justify-center space-x-3">
                  <span className="px-3 py-1.5 bg-green-100 text-green-800 rounded-full text-xs font-medium">Calidad Brasileña</span>
                  <span className="px-3 py-1.5 bg-yellow-100 text-yellow-800 rounded-full text-xs font-medium">Precio Competitivo</span>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden">
              <div className="p-10 text-center">
                <div className="flex items-center justify-center gap-4 mb-6">
                  <img 
                    src={brands[3].logo} 
                    alt="Maquinaria China"
                    className="h-20 object-contain"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Henan Deman Pack - China</h3>
                <p className="text-gray-600 text-base leading-relaxed mb-5">Hilo polyester de fabricación china con excelente calidad. Unico en el mercado con certificación FDA ISO 9000/14000</p>
                <div className="flex justify-center space-x-3">
                  <span className="px-3 py-1.5 bg-red-100 text-red-800 rounded-full text-xs font-medium">Tecnología Moderna</span>
                  <span className="px-3 py-1.5 bg-orange-100 text-orange-800 rounded-full text-xs font-medium">Gran Variedad</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section id="productos" className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Catálogo de Productos mas Vendidos</h2>
            <p className="text-xl text-gray-600">Maquinaria industrial y repuestos originales de Newlong, Union Special y Waig</p>
          </div>

          {/* Category Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((category) => (
              <button 
                key={category.id}
                onClick={() => {
                  setSelectedCategory(category.id);
                  setVisibleProducts(9);
                }}
                className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap text-sm ${
                  selectedCategory === category.id 
                    ? 'bg-blue-600 text-white shadow-lg' 
                    : 'bg-white text-gray-700 hover:bg-gray-50 border-2 border-gray-200 hover:border-blue-300'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
            {filteredProducts.slice(0, visibleProducts).map((product) => (
              <a 
                key={product.id}
                href="#contacto"
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200 transform hover:-translate-y-2 cursor-pointer block"
              >
                <div className="relative">
                  <div className="w-full h-80">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-contain object-center p-4 bg-gray-50"
                    />
                  </div>
                  <div className="absolute top-4 right-4">
                    <span className="px-3 py-1.5 bg-blue-100 text-blue-800 rounded-full text-xs font-semibold">
                      {categories.find(c => c.id === product.category)?.name.split(' ').pop()}
                    </span>
                  </div>
                </div>
                <div className="p-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-6 leading-tight">{product.name}</h3>
                  <ul className="space-y-2 mb-6">
                    {product.features.slice(0, 3).map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-600">
                        <i className="ri-check-line text-green-500 mr-3 text-lg flex-shrink-0"></i>
                        <span className="text-sm">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <span 
                    className="block w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold transition-all whitespace-nowrap hover:shadow-lg text-center"
                  >
                    {t('buttons.requestInfo', 'Solicitar Información')}
                  </span>
                </div>
              </a>
            ))}
          </div>

          {/* Load More Button */}
          {visibleProducts < filteredProducts.length && (
            <div className="text-center mt-16">
              <button 
                onClick={() => setVisibleProducts(prev => prev + 9)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-10 py-4 rounded-lg font-semibold transition-all whitespace-nowrap border-2 border-gray-200 hover:border-gray-300"
              >
                {t('buttons.loadMore', 'Ver Más Productos')} ({filteredProducts.length - visibleProducts} restantes)
              </button>
            </div>
          )}

        </div>
      </section>

      {/* Industries Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Sectores que Atendemos</h2>
            <p className="text-xl text-gray-600">Soluciones especializadas para diferentes industrias en toda Latinoamérica</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-green-200">
              <div className="w-20 h-20 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-plant-line text-3xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Agrícola</h3>
              <p className="text-sm text-gray-600 leading-relaxed">Envasado de granos, cereales y productos agrícolas</p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-orange-200">
              <div className="w-20 h-20 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-restaurant-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Alimenticio</h3>
              <p className="text-sm text-gray-600 leading-relaxed">Empaque de alimentos y productos comestibles</p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-purple-200">
              <div className="w-20 h-20 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-shirt-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Textil</h3>
              <p className="text-sm text-gray-600 leading-relaxed">Costura y acabado de productos textiles</p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-blue-200">
              <div className="w-20 h-20 bg-blue-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-settings-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Industrial</h3>
              <p className="text-sm text-gray-600 leading-relaxed">Manufactura y procesos industriales</p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all border border-gray-100 hover:border-red-200">
              <div className="w-20 h-20 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <i className="ri-truck-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">Logístico</h3>
              <p className="text-sm text-gray-600 leading-relaxed">Empaque y distribución de mercancías</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8">¿Listo para Transformar su Operación?</h2>
          <p className="text-xl md:text-2xl mb-12 text-blue-100 max-w-4xl mx-auto leading-relaxed">
            Únase a más de 500 empresas que han optimizado sus procesos con nuestras soluciones industriales. 
            Obtenga una cotización personalizada sin compromiso.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-16">
            <Link to="/solicitar-cotizacion" className="bg-white text-blue-600 hover:bg-gray-100 px-10 py-4 rounded-lg font-bold transition-all whitespace-nowrap shadow-xl text-lg hover:shadow-2xl transform hover:-translate-y-1 text-center">
              Solicitar Cotización Gratuita
            </Link>
            <a href="#contacto" className="border-2 border-white text-white hover:bg-white hover:text-blue-600 px-10 py-4 rounded-lg font-bold transition-all whitespace-nowrap text-lg hover:shadow-xl transform hover:-translate-y-1 text-center cursor-pointer">
              Hablar con un Especialista
            </a>
          </div>

          {/* Banner de Instalaciones y Operaciones */}
          <div className="max-w-4xl mx-auto">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-white/20">
              <div className="w-full h-80 relative">
                {carouselImages.map((image, index) => (
                  <img 
                    key={index}
                    src={image} 
                    alt={`Instalación ${index + 1}`}
                    className={`absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ${
                      currentSlide === index ? 'opacity-100' : 'opacity-0'
                    }`}
                  />
                ))}
              </div>
              
              {/* Controles del banner */}
              {carouselImages.length > 1 && (
                <>
                  <button 
                    onClick={prevSlide}
                    className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-left-s-line text-gray-900 text-xl"></i>
                  </button>
                  <button 
                    onClick={nextSlide}
                    className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-gray-900 text-xl"></i>
                  </button>
                  
                  {/* Indicadores */}
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                    {carouselImages.map((_, index) => (
                      <button
                        key={index}
                        onClick={() => setCurrentSlide(index)}
                        className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                          currentSlide === index ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/70'
                        }`}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contacto" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Contacto Directo</h2>
            <p className="text-xl text-gray-600">Estamos aquí para atenderle desde Miami con alcance a toda Latinoamérica</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Left Column - Contact Info */}
            <div>
              <div className="mb-8">
                <img 
                  src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d03d7dd558dd59549242c09cb047b58f.png" 
                  alt="IKIGAI Global Group Inc." 
                  className="h-16 w-auto mb-6"
                />
                <p className="text-gray-600 text-lg leading-relaxed">
                  Distribución directa de fábrica de maquinaria industrial para coser sacos y repuestos originales. 
                  Su socio estratégico en equipos industriales de alta calidad.
                </p>
              </div>

              {/* Office Image */}
              <div className="mb-8 rounded-2xl overflow-hidden shadow-xl border border-gray-200">
                <div className="w-full h-64">
                  <img 
                    src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/354a1669bd41cda327c0534abdf55ecf.png" 
                    alt="Almacén Principal IKIGAI Global Group - Miami, Florida"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div className="bg-white p-4 border-t border-gray-100">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-building-2-line text-blue-600"></i>
                    </div>
                    <div>
                      <p className="font-bold text-gray-900">Almacén Principal</p>
                      <p className="text-sm text-gray-600">Miami, Florida, Estados Unidos</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Details Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-phone-line text-green-600"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Teléfono</h4>
                  </div>
                  <p className="text-gray-800 font-semibold">+1 (305) 792-8462</p>
                  <p className="text-xs text-gray-500 mt-1">Atención en español</p>
                </div>

                <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-mail-line text-indigo-600"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Email</h4>
                  </div>
                  <p className="text-gray-800 font-semibold text-sm">admin@ikigaigroupusa.com</p>
                  <p className="text-xs text-gray-500 mt-1">Respuesta en 24 horas</p>
                </div>

                <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-time-line text-purple-600"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Horario</h4>
                  </div>
                  <p className="text-gray-800 font-semibold text-sm">Lun - Vie: 8AM - 6PM</p>
                  <p className="text-xs text-gray-500 mt-1">Hora EST (Miami)</p>
                </div>

                <div className="bg-white rounded-xl p-5 shadow-md border border-gray-100 hover:shadow-lg transition-shadow">
                  <div className="flex items-center mb-3">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                      <i className="ri-global-line text-orange-600"></i>
                    </div>
                    <h4 className="font-bold text-gray-900">Cobertura</h4>
                  </div>
                  <p className="text-gray-800 font-semibold text-sm">Toda Latinoamérica</p>
                  <p className="text-xs text-gray-500 mt-1">15+ países atendidos</p>
                </div>
              </div>

              {/* Distribution Network */}
              <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-map-2-line text-blue-600 mr-2"></i>
                  Red de Distribución Global
                </h4>
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <span className="text-2xl mr-3">🇺🇸</span>
                      <span className="font-semibold text-gray-900">Miami, FL</span>
                    </div>
                    <span className="text-sm text-gray-600">Centro principal</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <span className="text-2xl mr-3">🇯🇵</span>
                      <span className="font-semibold text-gray-900">Tokio, Japón</span>
                    </div>
                    <span className="text-sm text-gray-600">Almacén Newlong</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <span className="text-2xl mr-3">🇧🇷</span>
                      <span className="font-semibold text-gray-900">Limeira, Brasil</span>
                    </div>
                    <span className="text-sm text-gray-600">Centro Sudamérica</span>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                    <div className="flex items-center">
                      <span className="text-2xl mr-3">🇨🇳</span>
                      <span className="font-semibold text-gray-900">Qingdao, China</span>
                    </div>
                    <span className="text-sm text-gray-600">Centro Asia</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Form */}
            <div className="bg-white p-10 rounded-3xl shadow-xl border border-gray-100 h-fit">
              <h3 className="text-2xl font-bold text-gray-900 mb-8">Solicitar Información</h3>
              <form className="space-y-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Nombre Completo *</label>
                  <input 
                    type="text" 
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Su nombre completo"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Email Corporativo *</label>
                  <input 
                    type="email" 
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="empresa@email.com"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">Empresa *</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      placeholder="Nombre de su empresa"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">País *</label>
                    <input 
                      type="text" 
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      placeholder="País de operación"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Tipo de Consulta</label>
                  <select className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all pr-8">
                    <option>Cotización de maquinaria</option>
                    <option>Repuestos y partes</option>
                    <option>Información general</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">Mensaje *</label>
                  <textarea 
                    rows={4}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="Describa sus necesidades específicas de maquinaria industrial..."
                  ></textarea>
                </div>
                <button 
                  type="submit"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white py-4 px-6 rounded-lg font-bold transition-all whitespace-nowrap hover:shadow-lg text-lg"
                >
                  Enviar Solicitud
                </button>

                <div className="mt-6 pt-6 border-t border-gray-200">
                  <div className="flex items-center justify-center space-x-2 text-sm text-gray-600 mb-4">
                    <i className="ri-time-line text-blue-600"></i>
                    <span>Respuesta garantizada en menos de 24 horas hábiles</span>
                  </div>
                  <div className="grid grid-cols-3 gap-4 text-center">
                    <div className="flex flex-col items-center">
                      <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mb-2">
                        <i className="ri-shield-check-line text-green-600"></i>
                      </div>
                      <span className="text-xs text-gray-600 font-medium">Datos Seguros</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mb-2">
                        <i className="ri-customer-service-2-line text-blue-600"></i>
                      </div>
                      <span className="text-xs text-gray-600 font-medium">Asesoría Experta</span>
                    </div>
                    <div className="flex flex-col items-center">
                      <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center mb-2">
                        <i className="ri-price-tag-3-line text-purple-600"></i>
                      </div>
                      <span className="text-xs text-gray-600 font-medium">Sin Compromiso</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div className="md:col-span-2">
              <img 
                src="https://static.readdy.ai/image/988cd9015f1a752aa44f40d73592c8cb/d03d7dd558dd59549242c09cb047b58f.png" 
                alt="IKIGAI Global Group Inc." 
                className="h-12 w-auto mb-6"
              />
              <p className="text-gray-400 text-lg leading-relaxed mb-6">
                Distribución directa de fábrica de maquinaria industrial para coser sacos y repuestos originales. 
                Su socio estratégico en equipos industriales de alta calidad desde Miami hacia toda Latinoamérica.
              </p>
              <div className="flex space-x-4">
                <a href="https://www.linkedin.com/company/ikigai-global-group-inc/" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-linkedin-line text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center hover:bg-blue-600 cursor-pointer transition-colors">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-6">Productos</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Cerradoras Newlong</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Cosedoras Industriales</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Máquinas Union Special</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Repuestos Originales</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Accesorios</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xl font-bold mb-6">Servicios</h4>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Asesoría Especializada</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Consultoría</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Mantenimiento</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Capacitación</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer transition-colors">Logística</a></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400">
            <p>&copy; 2024 IKIGAI Global Group Inc. Todos los derechos reservados.</p>
            <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors mt-4 md:mt-0">Website Builder</a>
          </div>
        </div>
      </footer>
    </div>
  );
}